export const EventClient = {
  /**
   * Initiate the event emitter
   */
  // constructor() {
  //   this.eventEmitter = new EventEmitter();
  // }
  events: {},
  /**
   * Adds the @listener function to the end of the listeners array
   * for the event named @eventName
   * Will ensure that only one time the listener added for the event
   *
   * @param {string} eventName
   * @param {function} listener
   */
  // on(eventName, listener) {
  //   console.log("making on " + eventName);
  //   this.eventEmitter.on(eventName, listener);
  // }
  on(event, listener, eventName) {
    if (!this.events[event]) this.events[event] = [];
    this.events[event].push({listener: listener, eventName: eventName});
  },
  /**
   * Will temove the specified @listener from @eventname list
   *
   * @param {string} eventName
   * @param {function} listener
   */
  // removeEventListener(eventName, listener) {
  //   this.eventEmitter.removeListener(eventName, listener);
  // }
  off(event, listener, eventName) {
    if (!this.events[event]) return;
    const newEvents = [];
    this.events[event].forEach(callback => {
      if (callback['eventName'] !== eventName) newEvents.push(callback);
    });
    this.events[event] = newEvents;
  },
  /**
   * Will emit the event on the evetn name with the @payload
   * and if its an error set the @error value
   *
   * @param {string} event
   * @param {object} payload
   * @param {boolean} error
   */
  // emit(event, payload, error = false) {
  //   console.log("emitting " + event);
  //   this.eventEmitter.emit(event, payload, error);
  // }
  emit(event, data) {
    if (!this.events[event]) return;
    this.events[event].forEach(callback => callback.listener(data));
  }

  /**
   * Returns the event emitter
   * Used for testing purpose and avoid using this during development
   */
  // getEventEmitter() {
  //   return this.eventEmitter;
  // }
}


// WEBPACK FOOTER //
// ./src/util/eventClient.js